const CONSTANTS = {
  REACT_QUERY: {
    KEYS: {
      RQ_GET_USER_LOGGED: 'RQ_GET_USER_LOGGED',
      RQ_GET_TODO_LIST: 'RQ_GET_TODO_LIST',
      GET_TODO_BY_ID: 'GET_TODO_BY_ID',
    },
  },
  SEED: {
    SELECTED_THEME: 'SELECTED_THEME',
  },
};

export default CONSTANTS;
